import askGamblers from 'assets/images/askGamblers.svg';
import casinoOnlineLogo from 'assets/images/casinoOnlineApproved.svg';
import casinosAnalyzer from 'assets/images/casinosAnalyzer.png';
import playResponsibly from 'assets/images/playResponsibly.svg';
import { ReactComponent as TgIcon } from 'assets/images/socialNetworks/telegram-icon.svg';
import { ReactComponent as WaIcon } from 'assets/images/socialNetworks/whats-app-icon.svg';
import { ImageComponent } from 'components/Image';
import { LanguageSwitcher } from 'components/LanguageSwitcher';
import { ScContainer } from 'components/styles/common';
import { ConfigContext } from 'contexts/config';
import { replacePlaceholder } from 'helpers/cms';
import { useFooterMenuList } from 'hooks/footerMenuList';
import { usePoliciesByCountryCode } from 'modules/policies/hooks/usePoliciesByCountryCode';
import SeoContent from 'modules/seo/content/SeoContent';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-navi';
import { AnjouanSeal } from './components/AnjouanSeal';
import { DownloadButtons } from './components/DownloadButtons';
import { TobiqueSeal } from './components/TobiqueSeal';
import { ALLOWED_DOMAINS, awardsImages } from './helper';
import {
  ScAddons,
  ScAwards,
  ScCopyright,
  ScFooter,
  ScLicenses,
  ScNav,
} from './styled';

export const TELEGRAM_URL = 'https://t.me/luckyelf';
export const WHATSAPP_URL =
  'https://whatsapp.com/channel/0029VaAmwZA17EmygmFiP13w';

export const Footer = () => (
  <ScFooter>
    <SeoContent />
    <ScContainer>
      <Awards />
      <Nav />
      <div className="footer-bottom-box">
        <Copyright />
        <div className="footer-bottom">
          <Licenses />
          <Addons />
        </div>
      </div>
    </ScContainer>
  </ScFooter>
);

const Nav = () => {
  const { t } = useTranslation();

  const footerMenuList = useFooterMenuList();

  return (
    <ScNav>
      <ul>
        {footerMenuList.map(
          ({ name, url, onClick, isHidden }, index) =>
            !isHidden && (
              <li key={index}>
                <Link href={url} onClick={onClick}>
                  {name}
                </Link>
              </li>
            )
        )}
        <li>
          <button id="intercomcustomLauncher" type="button">
            {t('glossary:helpdesk')}
          </button>
        </li>
      </ul>
    </ScNav>
  );
};

const Copyright = () => {
  const currentFullYear = new Date().getFullYear();

  const { footerCopyright } = useContext(ConfigContext);
  const licenseContent = usePoliciesByCountryCode(footerCopyright);

  const license = replacePlaceholder(
    licenseContent,
    'year',
    String(currentFullYear)
  );

  return (
    <ScCopyright>
      <div className="license-link">
        <TobiqueSeal />
        <AnjouanSeal />
      </div>
      <div
        className="copyright"
        dangerouslySetInnerHTML={{ __html: license }}
      />
    </ScCopyright>
  );
};

const Addons = () => {
  const { t } = useTranslation('common');

  return (
    <ScAddons>
      <div className="col">
        <LanguageSwitcher />
      </div>
      <DownloadButtons />
      <div className="col">
        <div className="social-network-box">
          <span>{t('socialNetworks.followUs')}</span>
          <Link href={TELEGRAM_URL} target={'_blank'}>
            <TgIcon />
          </Link>
          <Link href={WHATSAPP_URL} target={'_blank'}>
            <WaIcon />
          </Link>
        </div>
      </div>
    </ScAddons>
  );
};

export const Licenses = () => {
  const isAllowedDomain = ALLOWED_DOMAINS.includes(window.location.hostname);
  return (
    <ScLicenses>
      <div className="licenses">
        <div>
          <Link
            href="https://luckyelfcasino.com/responsible-gaming"
            target={'_blank'}
          >
            <ImageComponent
              alt="play responsibly"
              height={44}
              src={playResponsibly}
              width={150}
            />
          </Link>
        </div>
        {isAllowedDomain && (
          <div>
            <Link
              href="https://casinosanalyzer.com/free-spins-no-deposit"
              target={'_blank'}
            >
              <ImageComponent
                alt="casinosAnalyzer"
                height={44}
                src={casinosAnalyzer}
                width={107}
              />
            </Link>
          </div>
        )}
        <div>
          <Link
            href="https://www.casino-on-line.com/review/lucky-elf-casino/"
            target={'_blank'}
          >
            <ImageComponent
              alt="casino-on-line"
              height={44}
              src={casinoOnlineLogo}
              width={188}
            />
          </Link>
        </div>
        <div>
          <Link
            href="https://www.askgamblers.com/online-casinos/reviews/lucky-elf-casino"
            target={'_blank'}
          >
            <ImageComponent
              alt="ask gamblers"
              height={44}
              src={askGamblers}
              width={133}
            />
          </Link>
        </div>
      </div>
    </ScLicenses>
  );
};

const Awards = () => (
  <ScAwards>
    {awardsImages.map(({ src, alt }, index) => (
      <ImageComponent alt={alt} height={44} key={index} src={src} width={202} />
    ))}
  </ScAwards>
);
